import { useSelector } from "react-redux"
import { DepartmentResponse } from "../../models/dtos"
import { RootState } from "../../store"
import { useAppDispatch } from "../../hooks/redux"
import { departmentsApi } from "../../services/nomenclatures/departmentsApi"
import { Skeleton } from "primereact/skeleton"
import Error from "../common/Error"
import FilterCard from "./FilterCard"
import FilterBox from "./FilterBox"

type DepartmentFilterProps = {
    getSelectedDepartments: (state: RootState) => DepartmentResponse[],
    setSelectedDepartments: any
}

const DepartmentsFilter = ({ getSelectedDepartments, setSelectedDepartments }: DepartmentFilterProps) => {
    const selectedDepartments = useSelector(getSelectedDepartments);
    const dispatch = useAppDispatch();

    const { data: departments, error, isLoading } = departmentsApi.useGetDepartmentsQuery();

    if (isLoading) return <Skeleton className="w-full h-2rem" />;
    if (error) return <Error error={error} />;

    return (
        <FilterCard title="По катедра:">
            <FilterBox<DepartmentResponse>
                filter
                value={selectedDepartments}
                onChange={(e) => dispatch(setSelectedDepartments(e.value))}
                options={departments?.data ?? []}
                optionLabel="name"
                listClassName="max-h-20rem"
                dataKey="departmentId"
            />
        </FilterCard>
    );
}

export default DepartmentsFilter;